import React from "react";
import ServicesLayout from "../ServicesLayout";
import MainSection from "./MainSection";
// import background from "../../../assets/images/banner/our_services.jpg";

export default function Services() {
  return (
    <ServicesLayout
      background="https://nct-social-media-icon.s3.ap-south-1.amazonaws.com/images/banner/our_services.jpg"
      pageTitle="Our Services"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Our Services", path: "/services" },
      ]}
    >
      <MainSection />
    </ServicesLayout>
  );
}
